import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Products List
export const getServiceList = createAsyncThunk(
  "getServiceList",
  async (
    {
      search,
      pageLimit,
      pageCount,
      category_id,
      sort_by,
      sort_direction,
      service_status,
      types,
      status,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `services?search=${search}&category_id=${
          category_id ?? ""
        }&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&service_status=${service_status}&types=${types}&status=${status}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Technician List
export const getTechnicianList = createAsyncThunk(
  "getTechnicianList",
  async ({ pageLimit }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`technicians?limit=${pageLimit}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create service
export const createService = createAsyncThunk(
  "createService",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`services`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create service
export const createSchedule = createAsyncThunk(
  "createSchedule",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`service-scheduling`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Signature
export const createSignature = createAsyncThunk(
  "createSignature",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`sign-service-request`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get service id
export const getServiceById = createAsyncThunk(
  "getServiceById",
  async ({ id, year }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`services/${id}?year=${year}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Get AllReport List
export const getAllReportList = createAsyncThunk(
  "getAllReportList",
  async ({ ids }, { rejectWithValue }) => {
    console.log("ids", ids);
    try {
      const url = `service-reports/view?ids=${encodeURIComponent(
        JSON.stringify(ids)
      )}`;
      const response = await AxiosApi.get(url);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// post AllReport List
export const sendAllReportList = createAsyncThunk(
  "sendAllReportList",
  async ({ ids }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`service-report/all`, { ids });
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get sales List
export const getSalesList = createAsyncThunk(
  "getSalesList",
  async ({ pageLimit }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`sales?limit=${pageLimit}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
export const getServiceReportById = createAsyncThunk(
  "getServiceReportById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`service-report/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Get ServiceReportList
export const getServiceReportList = createAsyncThunk(
  "getServiceReportList",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction, outlet, types },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `service-report?search=${search}&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&outlet
        =${outlet}&types=${types}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Remark
export const createRemark = createAsyncThunk(
  "createRemark",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`service-remark`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// mark-as-completed
export const markAsCompleted = createAsyncThunk(
  "markAsCompleted",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`/mark-as-completed/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Get ServiceReportList
export const getServiceSchedulingList = createAsyncThunk(
  "getServiceSchedulingList",
  async (
    {
      search,
      pageLimit,
      pageCount,
      sort_by,
      sort_direction,
      status,
      technician,
      recurring_status,
      company,
      recurring_status_dropdown,
      service_request_type_id,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `service-request-scheduled-list?search=${search}&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&technician=${technician}&sort_direction=${sort_direction}&status=${status}&recurring_status=${recurring_status}&company=${company}&recurring_status_dropdown=${recurring_status_dropdown}&service_request_type_id=${service_request_type_id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get getServiceSchedulingById
export const getServiceSchedulingById = createAsyncThunk(
  "getServiceSchedulingById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `service-request-scheduled-list/${id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Doc
export const createDocument = createAsyncThunk(
  "createDocument",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`service-report/download`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// post AllService List
export const sendAllServiceList = createAsyncThunk(
  "sendAllServiceList",
  async ({ ids }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`service-request/pushtosales`, {
        ids,
      });
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get service id
export const createServiceByReport = createAsyncThunk(
  "createServiceByReport",
  async ({ id, type }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`/reports/${id}`, {
        type: type,
      });
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response?.data?.message || "An error occurred.");
      return rejectWithValue(error.response?.data);
    }
  }
);
const serviceSlice = createSlice({
  name: "service",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Products List
      .addCase(getServiceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.getServiceListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Technician List
      .addCase(getTechnicianList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTechnicianList.fulfilled, (state, action) => {
        state.loading = false;
        state.getTechnicianListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getTechnicianList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Product
      .addCase(getServiceById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceById.fulfilled, (state, action) => {
        state.loading = false;
        state.getServiceByIdStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceById.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Product
      .addCase(getAllReportList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllReportList.fulfilled, (state, action) => {
        state.loading = false;
        state.getAllReportListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getAllReportList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get getSalesList
      .addCase(getSalesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesList.fulfilled, (state, action) => {
        state.loading = false;
        state.getSalesListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSalesList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get ServiceReportList
      .addCase(getServiceReportList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceReportList.fulfilled, (state, action) => {
        state.loading = false;
        state.getServiceReportListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceReportList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get ServiceReportList by id
      .addCase(getServiceReportById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceReportById.fulfilled, (state, action) => {
        state.loading = false;
        state.getServiceReportByIdStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceReportById.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get ServiceSchedulingList
      .addCase(getServiceSchedulingList.pending, (state) => {
        state.getServiceSchedulingListStatus.loading = true;
      })
      .addCase(getServiceSchedulingList.fulfilled, (state, action) => {
        state.getServiceSchedulingListStatus.loading = false;
        state.getServiceSchedulingListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceSchedulingList.rejected, (state) => {
        state.getServiceSchedulingListStatus.loading = false;
        state.error = true;
      })
      // get ServiceSchedulingList
      .addCase(getServiceSchedulingById.pending, (state) => {
        state.getServiceSchedulingByIdStatus.loading = true;
      })
      .addCase(getServiceSchedulingById.fulfilled, (state, action) => {
        state.getServiceSchedulingByIdStatus.loading = false;
        state.getServiceSchedulingByIdStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServiceSchedulingById.rejected, (state) => {
        state.getServiceSchedulingByIdStatus.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = serviceSlice;
export default reducer;
